export default {
  find(needleIn, haystackIn) {
    if (!needleIn) return true;
    const needle = needleIn.toString().toLowerCase();
    const haystack = haystackIn.toString().toLowerCase();
    if (haystack.search(needle) > -1) return true;
    const needleAlt = this.switchLatCyr(needle);
    return haystack.search(needleAlt) > -1;
  },
  enum2array(str) {
    if (!str || str === '') return [];
    return str.toString().replace(/'/g, '').split(',');
  },
  switchChars(rule, str) {
    const out = [];
    for (let i = 0; i < str.length; ++i) {
        out[out.length] = rule[str[i]] || str[i];
    }
    return out.join('');
  },
  numberFormat(num, decimals) {
    const val = decimals ? (num * 1).toFixed(2) : (num * 1);
    return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
  },
  compare(aVal, bVal, dir) {
    const m = dir || 1;
    if (aVal === bVal) return 0;
    const aNum = Number(aVal);
    const bNum = Number(bVal);
    if (!Number.isNaN(aNum) && !Number.isNaN(bNum)) {
      return aNum > bNum ? m : -m;
    }
    if (aVal == null) return -m;
    if (bVal == null) return m;
    return aVal.toString().localeCompare(bVal) * m;
  },
  switchLatCyr(str) {
    const rule = {
      // all
      'q': 'й',
      'w': 'ц',
      'e': 'у',
      'r': 'к',
      't': 'е',
      'y': 'н',
      'u': 'г',
      'i': 'ш',
      'o': 'щ',
      'p': 'з',
      '[': 'х',
      ']': 'ъ',
      'a': 'ф',
      's': 'ы',
      'd': 'в',
      'f': 'а',
      'g': 'п',
      'h': 'р',
      'j': 'о',
      'k': 'л',
      'l': 'д',
      ';': 'ж',
      '\'': 'э',
      'z': 'я',
      'x': 'ч',
      'c': 'с',
      'v': 'м',
      'b': 'и',
      'n': 'т',
      'm': 'ь',
      ',': 'б',
      '.': 'ю',
      // uppercase
      '{': 'х',
      '}': 'ъ',
      ':': 'ж',
      '"': 'э',
      '<': 'б',
      '>': 'ю'
    };
    return this.switchChars(rule, str);
  }
};
